var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('button',{staticClass:"closeBtn",attrs:{"id":"closeBtn"},on:{"click":_vm.closeModal}},[_vm._v("×")]),(_vm.media)?_c('Media',{attrs:{"media":_vm.media}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }